module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-small-sorority-path-cfb5d8f8ccd68bb56b2d77b7dd529b70.svg";